var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9bqvqua04a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 18a1 1 0 0 1 .994.883L21 19v1.5a2.5 2.5 0 0 1-2.302 2.492L18.5 23H14a1 1 0 0 1-.116-1.993L14 21h4.5a.5.5 0 0 0 .494-.421L19 20.5V19a1 1 0 0 1 1-1zM18.5 3a2.5 2.5 0 0 1 2.492 2.302L21 5.5V7a1 1 0 0 1-1.993.117L19 7V5.5a.5.5 0 0 0-.421-.494L18.5 5H14a1 1 0 0 1-.116-1.993L14 3h4.5zM9.915.041a1.696 1.696 0 0 1 1.454.349A1.732 1.732 0 0 1 12 1.73v20.545a1.742 1.742 0 0 1-.59 1.305 1.7 1.7 0 0 1-1.369.4l-8.582-1.215a1.71 1.71 0 0 1-1.057-.6A1.74 1.74 0 0 1 0 21.045V3.876c.007-.385.14-.758.38-1.059.244-.305.583-.519.936-.598L9.915.041zM10 2.082 2 4.108v16.714l8 1.133V2.082zM8 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm12.707 5.707a1 1 0 0 1-1.497-1.32l.083-.094L20.584 14H15a1 1 0 0 1-.116-1.993L15 12h5.637l-1.264-1.304a1 1 0 0 1-.063-1.321l.085-.093a1 1 0 0 1 1.321-.063l.093.085 2.894 2.985.004.004.006.006.005.005a.982.982 0 0 1 .188 1.12c-.043.092-.1.178-.168.253l-3.03 3.03z",
    fill: "#8A8DAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9bqvqua04a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fe845be43ebab2f00ea73d1ba3fdf062.svg";
export { ForwardRef as ReactComponent };